import { useMutation } from "@tanstack/react-query";
import { checkUser } from "../services/users.service";

export const useCheckUser = () => {
  return useMutation({
    mutationFn: checkUser,
  });
};
